
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.isOpen = false;
    this.focusFrame = null;

    if (!this.notification) return;

    this.notification.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        event.preventDefault();
        this.close();
      }
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
  }

  open() {
    if (!this.notification) return;

    this.isOpen = true;

    this.notification.classList.add('animate', 'active');

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.addEventListener('click', this.onBodyClick);

    // Do not depend on CSS animation completion.
    // This also works when reduced motion is enabled.
    if (this.focusFrame !== null) {
      cancelAnimationFrame(this.focusFrame);
    }

    this.focusFrame = requestAnimationFrame(() => {
      this.focusFrame = null;

      if (!this.isOpen) return;

      this.notification.focus();

      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }
    });
  }

  close() {
    if (!this.notification || !this.isOpen) return;

    this.isOpen = false;

    if (this.focusFrame !== null) {
      cancelAnimationFrame(this.focusFrame);
      this.focusFrame = null;
    }

    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections[section.id];

      if (!target || !html) return;

      const content = this.getSectionInnerHTML(
        html,
        section.selector
      );

      if (content !== null) {
        target.innerHTML = content;
      }
    });

    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentFragment = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = documentFragment.querySelector(selector);

    return element ? element.innerHTML : null;
  }

  handleBodyClick(event) {
    if (!this.notification || !this.isOpen) return;

    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : this.activeElement;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
